/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SystemSettingDataTypes {
    StringSingleLine = 10,
    StringMultiLine = 20,
    HTML = 80,
}
